import { createSelector } from 'reselect';
import objectToArray from '../../../../common/utils/object-to-array';

const transactionsStateSelector = ({ entities: { transactions } = {} }) =>
  transactions;

export const getTransactions = createSelector(
  [transactionsStateSelector],
  transactions => {
    return objectToArray(transactions || {});
  }
);



// WEBPACK FOOTER //
// ./src/App/account/selectors/transactions/index.js